<template>
  <CRow>
    <CCol sm="12" class="justify-content-md-center mt-4 blockAudienceStar position-relative dataTable">
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>
      <CRow>
        <h1 class="mb-5 mt-5 titlePage font-weight-normal text-capitalize" style="color: #22252b">Segments Details</h1>
        <CCol sm="12" class="mb-2 p-0">
          <a
            @click="$router.push({ name: 'segments-list' })"
            class="text-decoration-none d-flex-inline align-items-center font-weight-normal text-gray-600"
            style="cursor: pointer"
          >
            <CIcon name="arrow" :height="20" class="icon__rotateLeft mr-2" viewBox="0 0 32 32" />
            BACK TO SEGMENTS LIST
          </a>
        </CCol>

        <CCol sm="12" class="mt-5">
          <v-select
            style="max-width: 300px"
            class="mb-0 no-close my-3"
            :options="segmentOptions"
            v-model="segmentSelected"
            :placeholder="currentlySegmentName"
            @input="changeSegmentListId"
            :loading="loadingSegmentOptions"
            :disabled="loadingSegmentOptions || loadingSegmentDetail || loadingContactList"
          >
          </v-select>
        </CCol>

        <CCol sm="12">
          <CRow>
            <CCol sm="12">
              <CRow>
                <CCol sm="12">
                  <HeaderActions
                    :show="{ checkItems: false, manage: false, orderByDate: false, manageSegment: true }"
                    typeName="Segment"
                    @deleteAll="deleteCurrentlyList"
                    @editSegment="editSegment"
                    @exportRecods="exportSegment"
                  />
                </CCol>

                <CCol sm="12">
                  <hr class="hrTable mb-5" />
                  <div class="mt-4 d-flex justify-content-between">
                    <div class="dataTable__countContants">
                      <h2 class="font-weight-lighter font-5xl">{{ overview.contacts }}<span class="font-xs text-uppercase ml-2">Contacts</span></h2>
                    </div>
                    <div class="divSearch">
                      <input type="text" class="form-control form-search" placeholder="SEARCH" v-model="search" />
                      <i class="fa fa-search serachBox" aria-hidden="true"></i>
                    </div>
                    <div class>
                      <router-link :to="{ name: 'campaign' }" class="btn btn-primary btn-audience-create">SEND CAMPAIGN</router-link>
                    </div>
                  </div>

                  <div class="mt-5">
                    <div class="loading" v-if="(loadingSegmentDetail || loadingContactList) && !recipients.length">
                      <CSpinner class="my-3" color="primary" />
                    </div>

                    <CCard class="dataTable" v-if="recipients.length">
                      <CCardBody class="dataTable__body p-0">
                        <CDataTable
                          :items="recipients"
                          :fields="headers"
                          :table-filter="{ external: true, lazy: true }"
                          items-per-page-select
                          :items-per-page.sync="count"
                          @pagination-change="paginationChange"
                          :active-page="1"
                          hover
                          :loading="loadingContactList"
                        >
                          <template #loading>
                            <div class="d-flex justify-content-center align-items-center dataTable__loading">
                              <CSpinner class="my-3" color="primary" />
                            </div>
                          </template>

                          <template #_MetaData="{ item }">
                            <OptInOut :opt="{ item }" :key="item.RecipientId" />
                          </template>

                          <template #_MetaData.Tags="{ item }">
                            <Tags :opt="{ item }" :key="item.RecipientId + 1" />
                          </template>

                          <template #_MetaData.UpdatedDatetime="{ item }">
                            <UpdatedDatetime :opt="{ item }" :key="item.RecipientId + Math.round(Math.random() * 100)" />
                          </template>
                        </CDataTable>
                      </CCardBody>
                      <CPagination
                        v-show="pages > 0 && totalRecords > 0"
                        align="center"
                        :pages="pages"
                        :active-page.sync="activePage"
                        class="dataTable__newPagination mt-3"
                      >
                        <template slot="previous-button">
                          <span class="newPagination__button p-2 btnPagination">
                            {{ $t('audience.audienceList.text.prev') }}
                          </span>
                        </template>
                        <template slot="next-button">
                          <span class="newPagination__button p-2 btnPagination">
                            {{ $t('audience.audienceList.text.next') }}
                          </span>
                        </template>
                      </CPagination>
                    </CCard>
                  </div>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
    </CCol>
  </CRow>
</template>

<script>
const columnAplication = [
  { key: '_MetaData', label: 'opt in  & opt out' },
  { key: '_MetaData.Tags', label: 'Tags' },
  {
    key: '_MetaData.UpdatedDatetime',
    label: 'LAST CHANGE',
    _style: 'min-width:200px',
  },
]

import services from '@/services.js'
import HeaderActions from '@/components/table/HeaderActions'
import vSelect from 'vue-select'
import OptInOut from '@/components/table/OptInOut'
import Tags from '@/components/table/Tags'
import UpdatedDatetime from '@/components/table/UpdatedDatetime'
import MenssageAlert from '@/components/MenssageAlert'
import { getErrorMessage } from '@/utils/errorHandling.js'

export default {
  name: 'SegmentsDetail',
  components: {
    HeaderActions,
    vSelect,
    OptInOut,
    Tags,
    UpdatedDatetime,
    MenssageAlert,
  },
  props: {},
  data() {
    return {
      page: 1,
      count: 10,
      startCountPag: 1,
      endCountPag: 10,
      allIsChecked: 0,
      openModal: false,
      search: '',
      loadingContactList: false,
      loadingSegmentDetail: false,
      loadingSegmentOptions: false,
      segmentSelected: null,
      segmentOptions: [],
      currentlySegmentName: '',
      overview: {},
      //recipients: [{"_id":"6024088f90131ca7886345d8","_MetaData":{"CreatedDatetime":"2020-12-02T13:48:51.017Z","UpdatedDatetime":"2021-03-04T09:27:17.801Z","CreatedFrom":{"Key":0,"Value":"FILE_IMPORT"},"Status":{"Key":0,"Value":"ACTIVE"},"Subscriptions":[],"Tags":["2020-12","TESTE","TAG_DOIS","TESTE_REFACTOR","TESTE_META"]},"Field1":"wiefbin@ewufbei.pt","Field2":"nfeuiefeiwb@fneuwei.com","Field3":"12345@teste.com"},{"_id":"6024088f90131ca7886345e6","_MetaData":{"CreatedDatetime":"2020-12-02T13:48:51.017Z","UpdatedDatetime":"2021-03-04T09:10:33.817Z","CreatedFrom":{"Key":0,"Value":"FILE_IMPORT"},"Status":{"Key":0,"Value":"ACTIVE"},"Subscriptions":["EMAIL"],"Tags":["CCCCC","NEWTAG","TAG_DOIS","TESTE_REFACTOR","NOVATAG"]},"Field1":"wiefbin@ewufbei.pt","Field2":"nfeuiefeiwb@fneuwei.com","Field3":"12345@teste.com"},{"_id":"6024088f90131ca7886345f1","_MetaData":{"CreatedDatetime":"2020-12-02T13:48:51.017Z","UpdatedDatetime":"2021-03-03T12:15:18.502Z","CreatedFrom":{"Key":0,"Value":"FILE_IMPORT"},"Status":{"Key":0,"Value":"ACTIVE"},"Subscriptions":["EMAIL"],"Tags":["2020-12","TESTE","TAG_DOIS","TESTE_REFACTOR"]},"Field1":"wiefbin@ewufbei.pt","Field2":"nfeuiefeiwb@fneuwei.com","Field3":"12345@teste.com"},{"_id":"6024088f90131ca788634623","_MetaData":{"CreatedDatetime":"2020-12-02T13:48:51.017Z","UpdatedDatetime":"2021-03-04T17:53:43.957Z","CreatedFrom":{"Key":0,"Value":"FILE_IMPORT"},"Status":{"Key":0,"Value":"ACTIVE"},"Subscriptions":["EMAIL"],"Tags":["2020-12","NEWTAG","TESTE_META","TESTE_REFACTOR","CCCCC"]},"Field1":"wiefbin@ewufbei.pt","Field2":"nfeuiefeiwb@fneuwei.com","Field3":"12345@teste.com"},{"_id":"6024088f90131ca78863465e","_MetaData":{"CreatedDatetime":"2020-12-02T13:48:51.017Z","UpdatedDatetime":"2021-03-03T12:54:36.527Z","CreatedFrom":{"Key":0,"Value":"FILE_IMPORT"},"Status":{"Key":0,"Value":"ACTIVE"},"Subscriptions":["EMAIL"],"Tags":["2020-12","TAG_DOIS","TESTE_META","TESTE","NOVATAG","NEWTAG","blas","blasss"]},"Field1":"wiefbin@ewufbei.pt","Field2":"nfeuiefeiwb@fneuwei.com","Field3":"12345@teste.com"},{"_id":"6024088f90131ca788634683","_MetaData":{"CreatedDatetime":"2020-12-02T13:48:51.017Z","UpdatedDatetime":"2021-03-03T15:13:19.347Z","CreatedFrom":{"Key":0,"Value":"FILE_IMPORT"},"Status":{"Key":0,"Value":"ACTIVE"},"Subscriptions":["EMAIL"],"Tags":["2020-12","TESTE","NEWTAG","TESTE_META","TAG_DOIS"]},"Field1":"wiefbin@ewufbei.pt","Field2":"nfeuiefeiwb@fneuwei.com","Field3":"12345@teste.com"},{"_id":"6024088f90131ca7886346cc","_MetaData":{"CreatedDatetime":"2020-12-02T13:48:51.017Z","UpdatedDatetime":"2021-03-03T19:56:37.07Z","CreatedFrom":{"Key":0,"Value":"FILE_IMPORT"},"Status":{"Key":0,"Value":"ACTIVE"},"Subscriptions":["EMAIL"],"Tags":["2020-12","TESTE","TAG_DOIS","TESTE_META","NEWTAG"]},"Field1":"wiefbin@ewufbei.pt","Field2":"nfeuiefeiwb@fneuwei.com","Field3":"12345@teste.com"},{"_id":"6024089090131ca78863470c","_MetaData":{"CreatedDatetime":"2020-12-02T13:48:51.017Z","UpdatedDatetime":"2021-03-03T19:51:51.123Z","CreatedFrom":{"Key":0,"Value":"FILE_IMPORT"},"Status":{"Key":0,"Value":"ACTIVE"},"Subscriptions":["EMAIL"],"Tags":[]},"Field1":"wiefbin@ewufbei.pt","Field2":"nfeuiefeiwb@fneuwei.com","Field3":"12345@teste.com"},{"_id":"6024089090131ca788634725","_MetaData":{"CreatedDatetime":"2020-12-02T13:48:51.017Z","UpdatedDatetime":"2021-02-09T16:50:12.472Z","CreatedFrom":{"Key":0,"Value":"FILE_IMPORT"},"Status":{"Key":0,"Value":"ACTIVE"},"Subscriptions":["EMAIL"],"Tags":["2020-12"]},"Field1":"wiefbin@ewufbei.pt","Field2":"nfeuiefeiwb@fneuwei.com","Field3":"12345@teste.com"},{"_id":"6024089090131ca788634752","_MetaData":{"CreatedDatetime":"2020-12-02T13:48:51.017Z","UpdatedDatetime":"2021-03-04T16:16:25.249Z","CreatedFrom":{"Key":0,"Value":"FILE_IMPORT"},"Status":{"Key":0,"Value":"ACTIVE"},"Subscriptions":["EMAIL"],"Tags":["2020-12","TAG_DOIS","TESTE_REFACTOR"]},"Field1":"wiefbin@ewufbei.pt","Field2":"nfeuiefeiwb@fneuwei.com","Field3":"12345@teste.com"}],
      recipients: [],
      query: {},
      messages: [],
      headers: [],
      activePage: 1,
      totalRecords: 0,
      pages: 1,
    }
  },

  methods: {
    paginationChange(a) {
      this.count = a
    },

    onTableChange() {
      this.page = this.activePage - 1
      this.getSegmentContactList()
    },

    headerHandle(arr) {
      let headers = arr.reduce((acc, cur) => {
        const isKey = cur.isKey ? 'KeyColumn' : ''
        acc.push({
          key: cur.fieldName,
          label: cur.value,
          isKey: cur.isKey,
          _classes: isKey,
          _style: cur.value == 'SMS' ? 'min-width:180px' : '',
        })
        return acc
      }, [])

      return [...headers, ...columnAplication]
    },

    async getHeaders(organizationId) {
      services
        .audienceSchema(organizationId)
        .then((schema) => {
          this.headers = this.headerHandle(schema.data.data.values)
        })
        .catch((error) => {
          this.messages = [getErrorMessage(error?.response?.data)]
        })
    },

    counterTable(count) {
      if (count < 10) {
        return count
      } else {
        return this.endCountPag
      }
    },

    getSegmentContactList() {
      let body = {
        pageOptions: {
          count: this.count,
          page: this.page - 1 <= 0 ? 0 : this.page - 1,
        },
        query: this.query,
      }
      this.loadingContactList = true
      services
        .getSegmentContactList(this.organizationId, body)
        .then((response) => {
          if (response?.data?.data) {
            let { reachSegmentPercentage, totalContacts, contactsPercentageOfTotal, lifetimeAov, lifetimeTotalRevenue, orderCount, contacts } =
              response.data.data

            this.overview = {
              reachSegmentPercentage,
              totalContacts,
              contactsPercentageOfTotal,
              lifetimeAov,
              lifetimeTotalRevenue,
              orderCount,
              contacts,
            }
            this.recipients = response.data.data.recipientResult.recipients
            this.totalRecords = response.data.data.recipientResult.pagination.totalRecords
            this.pages = response.data.data.recipientResult.pagination.totalPages
            this.activePage = response.data.data.recipientResult.pagination.currentPage + 1
            this.pagination = response.data.data.recipientResult.pagination

            this.setOverviewValue(response.data.data)
          }
        })
        .catch((error) => {
          this.messages = [getErrorMessage(error?.response?.data)]
        })
        .finally(() => (this.loadingContactList = false))
    },
    getSegmentOptions() {
      this.loadingSegmentOptions = true
      services
        .getClientSegmentsList(this.organizationId, 0, 999)
        .then((response) => {
          const segments = response.data.data.segments
          segments.forEach((segment) => this.segmentOptions.push({ label: segment.name, value: segment._id, segmentIdGuid: segment.segmentId }))
        })
        .catch((error) => {
          this.messages = [getErrorMessage(error?.response?.data)]
        })
        .finally(() => {
          this.loadingSegmentOptions = false
        })
    },
    getSegmentDetail() {
      this.loadingSegmentDetail = true
      services
        .getSegment(this.organizationId, this.segmentIdGuid)
        .then((response) => {
          const segmentData = response.data.data

          this.currentlySegmentName = segmentData.name
          this.query = segmentData.query

          this.getSegmentContactList()
        })
        .catch((error) => {
          this.messages = [getErrorMessage(error?.response?.data)]
        })
        .finally(() => {
          this.loadingSegmentDetail = false
        })
    },

    verifyPagination() {
      if (this.page === 0) {
        return 1
      }

      if (this.page > 0) {
        return 0
      }
    },

    verifyPaginationNext(count) {
      if (count < 10) {
        return 1
      }

      if (count >= 10) {
        return 0
      }
    },

    deleteCurrentlyList() {
      let segmentsList = []
      segmentsList.push(this.segmentId)
      services
        .deleteClientSegment(this.organizationId, segmentsList)
        .then((response) => {
          this.$router.push({ name: 'segments-list', params: { message: 'Segment successfully deleted!', status: 'success' } })
        })
        .catch((error) => {})
    },

    nextPage(count) {
      if (count < 10) {
        return
      }
      this.page = this.page + 1
      this.startCountPag = this.startCountPag + 10
      this.endCountPag = this.endCountPag + 10
      this.getSegmentContactList()
    },

    previousPage() {
      if (this.page === 0) {
        return
      }
      this.startCountPag = this.startCountPag - 10
      this.endCountPag = this.endCountPag - 10
      this.page = this.page - 1
      this.getSegmentContactList()
    },

    goToDatail(recipient) {
      this.$router.push({ name: 'contact-detail', params: { id: recipient._id } })
    },

    changeSegmentListId() {
      this.$router.push({ name: 'segments-details', params: { id: this.segmentSelected.value, segmentIdGuid: this.segmentSelected.segmentIdGuid } })
    },

    editSegment() {
      this.$router.push({ name: 'segments-edit', params: { id: this.segmentId, segmentIdGuid: this.segmentIdGuid } })
    },

    exportSegment(body) {
      services
        .exportSegment(this.organizationId, { ...body, segmentId: this.segmentIdGuid })
        .then(() => {
          this.statePopUpManage = false

          this.$store.commit('setToastMessage', {
            title: 'EXPORT OF AUDIENCE',
            text: 'Your request is being processed',
          })
        })
        .catch((error) => {
          this.messages = [getErrorMessage(error?.response?.data)]
        })
    },

    setOverviewValue(overview) {
      this.$store.commit('UPDATE_OVERVIEW', overview)
    },
  },

  mounted() {
    this.getHeaders(this.organizationId)
    this.getSegmentDetail()
    this.getSegmentOptions()
  },

  watch: {
    reloadParams(newValue, oldValue) {
      // TODO precisei fazer isso para impedir 2 requisições ao entrar na pagina.
      // caso entre mais props no getdata() terá que mudar o indice do array newValue[3], oldValue[3]
      // newValue[3] pagina atual -  oldValue[3] pagina antiga
      if (newValue[0] == 1 && oldValue[0] == 0) return
      this.onTableChange()
    },
  },

  computed: {
    filteredItems() {
      return this.recipients.filter((item) => {
        return item.Field1.toLowerCase().indexOf(this.search.toLowerCase()) > -1
      })
    },

    reloadParams() {
      return [this.activePage, this.itemsPerPage, this.tableFilterValue]
    },

    segmentId() {
      return this.$route.params.id
    },

    segmentIdGuid() {
      return this.$route.params.segmentIdGuid
    },

    organizationId() {
      return this.$store.state.auth.organizationId
    },

    detailPagination() {
      const first = (this.page - 1) * this.count + 1
      return `${first} - ${this.page * 10}  of ${this.totalRecords}`
    },
  },
}
</script>

<style lang="scss" scoped>
.modalCancel {
  position: relative;
  margin-left: 0px;
  margin-top: 30px;
  width: 360px;
  z-index: 1;
  &__body {
    background: #fff;
    position: absolute;
    width: 100%;
    max-width: 360px;
    border: 2px solid #edeff1;
  }
}

.btn-audience-create {
  color: white !important;
  text-decoration: none !important;
  float: right;
  padding: 1rem 1.5rem;
  font-weight: bold;
}

.hide {
  display: none;
}

.paginationText {
  color: #a1a8b3;
  line-height: 3;
}

.trash-list {
  position: absolute;
  left: 60px;
  top: 3px;
  font-size: 15px;
  color: #a1a8b3;
  cursor: pointer;
}

.boxPag {
  background-color: #fff;
  width: 50px;
  height: 45px;
  line-height: 2.9;
  text-align: center;
  color: #d1d4da;
  cursor: pointer;
}

.boxPag:hover {
  background-color: #edeff1;
}

.box-pag-bg-disable {
  background-color: #edeff1 !important;
}

p {
  line-height: 1rem;
}

.form-search {
  font-size: 1rem;
  width: 500px;
  height: 50px;
  padding-left: 40px;
}

.divSearch {
  position: relative;
}

.serachBox {
  color: #9da5ab;
  position: absolute;
  top: 15px;
  left: 10px;
  font-size: 20px;
}

.hrTable {
  border-top: 1px solid #d1d4da;
  margin-bottom: 0;
  margin-top: 0;
}

.textDateCreated {
  color: #a1a8b3;
  font-size: 14px;
}

.iconDateCreated {
  color: #a1a8b3;
  font-size: 15px;
  margin-left: 7px;
  margin-right: 8px;
  cursor: pointer;
}

.table td {
  padding: 0.85rem 2rem;
  border-top: none;
}

.trLine:hover {
  background-color: #fff;
  cursor: pointer;
  color: #656971;
  -webkit-box-shadow: -1px -1px 16px -8px rgba(94, 94, 94, 0.73) !important;
  -moz-box-shadow: -1px -1px 16px -8px rgba(94, 94, 94, 0.73) !important;
  box-shadow: -1px -1px 16px -8px rgba(94, 94, 94, 0.73) !important;
  border: none !important;
}

.table {
  background-color: #fff;
  overflow-x: auto;
  white-space: nowrap;
}

.table tr {
  border-top: 2px solid #edeff1;
}

.tableCustom thead {
  border: 0;
}

.tableCustom th {
  vertical-align: middle;
  overflow: hidden;
  border-bottom: 2px solid var(--white);
  font-weight: normal;
  padding: 1.4rem 2rem;
  border-top: 0;
  background: var(--gray-200);
}

.trChecked {
  background-color: #edeff1;
}

.trChecked:hover {
  background-color: #edeff1 !important;
}

.containerCheck {
  display: block;
  position: relative;
  margin-bottom: 12px;
  margin-left: 3px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.containerCheck input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #fff;
  border: 1px solid #ccc;
}

/* On mouse-over, add a grey background color */
.containerCheck:hover input ~ .checkmark {
  background-color: #fff;
}

/* When the checkbox is checked, add a blue background */
.containerCheck input:checked ~ .checkmark {
  background-color: #ff5924;
  border: 1px solid #ff5924;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.containerCheck input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.containerCheck .checkmark:after {
  left: 6px;
  top: 4px;
  width: 5px;
  height: 8px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.CSpinner {
  border: none;
  width: 83px;
  height: 83px;
  background: url(/img/icons/spinner.gif);
}

.loading {
  width: 100%;
  background-color: white;
  text-align: center;
  margin-bottom: 20px;
  padding-top: 50px;
  padding-bottom: 50px;
}
</style>
<style module>
.blockClick {
  pointer-events: none;
}
</style>
